export default {
  "about": {
    "careersDetails": {
      "anqing": "Anqing",
      "applyResume": "Submit a Resume",
      "backToPrevious": "Back to Previous",
      "category": "Category: ",
      "education": "Education: ",
      "errors": {
        "getInfoFailed": "Failed to get information",
        "getJobDetailFailed": "Failed to get job details",
        "getJobDetailFailedRetry": "Failed to get job details,please try again later",
        "jobNotExist": "Job information does not exist",
        "parseInfoFailed": "Failed to parse information"
      },
      "jobDescription": "Job Description",
      "jobRequirements": "Job Requirements",
      "nationwide": "Nationwide",
      "noJobInfo": "Job information does not exist",
      "person": "person",
      "recruitmentCount": "Recruitment Count: ",
      "salary": "Salary: ",
      "suzhou": "Suzhou",
      "workLocation": "Work Location: ",
      "workYear": "Working Experience:"
    },
    "contact": {
      "address": "Address: ",
      "contactInfo": "Contact Information",
      "email": "Email: ",
      "errors": {
        "getContactFailed": "Failed to get contact information"
      },
      "pageTitle": "Contact Us",
      "phone": "Phone: ",
      "postcode": "Postcode: "
    },
    "page": {
      "careers": {
        "activities": {
          "balance": {
            "description": "Advocating work-life balance",
            "subtitle": "KEEP BALANCED",
            "title": "Balance and Excellence"
          },
          "learning": {
            "description": "Building a learning organization and promoting lifelong learning",
            "subtitle": "KEEP LEARNING",
            "title": "Endless Learning"
          }
        },
        "category": "Category: ",
        "errors": {
          "getAreaFailed": "Failed to get work locations",
          "getAreaFailedRetry": "Failed to get work locations,please try again later",
          "getCategoryFailed": "Failed to get job categories",
          "getCategoryFailedRetry": "Failed to get job categories,please try again later",
          "getJobsFailed": "Failed to get job list",
          "getJobsFailedRetry": "Failed to get job list,please try again later",
          "getNatureFailed": "Failed to get job nature",
          "getNatureFailedRetry": "Failed to get job nature,please try again later"
        },
        "jobCategory": "Job Category",
        "jobNature": "Job Nature",
        "nationwide": "Nationwide",
        "noData": "No Data",
        "noJobs": "No related positions",
        "publishDate": "Published",
        "searchBox": {
          "campusRecruitment": "Campus Recruitment",
          "placeholder": "Please enter keywords",
          "search": "Search",
          "socialRecruitment": "Social Recruitment"
        },
        "viewDetail": "View Details>",
        "workLocation": "Work Location"
      },
      "company": {
        "companyIntro": "Established in 2003 and headquartered in Suzhou, China. Yacoo Science has evolved through continuous innovation into a national high-tech enterprise with fully integrated capabilities in research and development, manufacturing. Business scope covers life sciences, personal care, new materials, b2star selection, testing services, etc.",
        "companyName": "Yacoo Science",
        "dataSection": {
          "founded": "Founded",
          "globalCustomers": "Global Customers",
          "globalPartners": "Global Partners",
          "patents": "Patent Applications",
          "productionBase": "Manufacturing Capacities",
          "salesCountries": "Sales Countries and Regions",
          "title": "Company Profile",
          "unit": "Tons",
          "year": "Year"
        },
        "history": {
          "title": "Development History"
        },
        "honor": {
          "title": "Honors and Qualifications"
        },
        "pageTitle": "About Company",
        "subtitle": "Yacoo Science，the global innovator and leader in medical and chemical materials. ",
        "vision": {
          "mission": {
            "description": "Committed to promoting technological progress and innovation in medical chemical materials",
            "title": "Mission"
          },
          "title": "Corporate Vision",
          "values": {
            "description": "Integrity and Gratitude,Responsibility and Diligence,Pragmatism and Perseverance,Innovation and Excellence",
            "title": "Core Values"
          },
          "vision": {
            "description": "To become a global innovation leader in medical and chemical materials.",
            "title": "Vision"
          }
        }
      },
      "production": {
        "intro": "Yacoo has stable and reliable manufacturing capabilities. Currently,we have built two production bases in Jining and Anqing,equipped with internationally leading production equipment and processes,focusing on the R&D and production of high-quality fine chemicals. The total capacity of each base exceeds 100,000 tons,and has passed ISO9001 quality management system,ISO14001 environmental management system and ISO45001 occupational health and safety management system certification.",
        "intro2": "Yacoo ensures that every batch of products meets industry high standards through a zero defect quality control system,continuously providing global customers with stable and reliable chemical supply solutions. Based on the competitive advantages of scale production capacity,intelligent production,and full-chain raw material control,we provide from scientific research to commercial production one-stop raw material solutions for strategic emerging industries such as medical health and biotechnology,helping customers achieve stable development.",
        "siteInfo": {
          "area": "Site Scale: ",
          "capacity": "Workshop & Capacity: ",
          "coreProducts": "Core Products: ",
          "field": "Application Fields: "
        },
        "title": "Production Base"
      },
      "quality": {
        "equipment": {
          "description": "By establishing a comprehensive testing instrument platform that includes high-performance liquid chromatographs,gas chromatographs,nuclear magnetic resonance spectrometers,polarimeters,infrared spectrometers,inductively coupled plasma atomic emission spectrometers,automatic potentiometric titrators,and Karl Fischer coulometric moisture analyzers,etc.,Yakee Co.,Ltd. can meet customers' high-precision and high-complexity release testing requirements in various influencing scenarios.",
          "devices": {
            "automaticTitrator": "Automatic Potentiometric Titrator",
            "broadbandNMR": "Broadband Multi-coil Nuclear Magnetic Resonance Spectrometer",
            "gcms": "GC-MS",
            "icpSpectrometer": "Inductively Coupled Plasma Emission Spectrometer",
            "infraredSpectrometer": "Infrared Spectrometer",
            "karlFischer": "Karl Fischer Coulometric Moisture Analyzer"
          },
          "title": "Testing Equipment"
        },
        "intro": "Yacoo ensures product quality through process control,focusing on providing customers with higher cost-effective diversified products and better services , with serving customer innovation as our mission. Based on Yacoo's 22 years of testing experience in the medical chemical materials field , our research analysis team led by several doctors provides customers with one-stop solutions from testing to technical optimization. ",
        "intro2": "Yacoo's testing platform has a 3000㎡ modern laboratory with a domestically leading air circulation and purification system to ensure safe and controllable testing environment. The platform is equipped with comprehensive chemical analysis space and complete high-end instruments to meet high-precision and high-complexity testing needs. According to laws and regulations and technical specifications of various countries/regions (such as EU REACH , US FDA , China CDE , etc.) , it helps customers avoid trade barriers and achieve product life cycle compliance management. ",
        "navigation": {
          "next": "Next",
          "prev": "Previous"
        },
        "system": {
          "description": "Yacoo has established a comprehensive medical chemical materials testing system covering structural characterization,physical and chemical properties,elemental analysis,spectrum analysis,stability studies,complete and traceable data,impurity analysis research,raw material testing,etc. Quality management has passed GMP system and ISO9001:2015 quality management system certification,supporting customers' global market development applications.",
          "title": "Testing System"
        },
        "title": "Quality Management"
      }
    },
    "tabs": {
      "careers": "Join Us",
      "company": "Company Profile",
      "production": "Production Base",
      "quality": "Quality Management"
    }
  },
  "dzhc": {
    "businessIntroText": 'Custom synthesis service is the core business of Yacoo. With 22 years of R&D experience in the field of medical chemical materials,Yacoo can provide customers with reliable and stable customized synthesis services. We have a team of senior scientists and engineers,and have built five major experimental platforms including AI intelligent synthesis,chemical synthesis,and biological synthesis,equipped with advanced testing platforms such as HPLC,GC,and polarimeter. In addition,Yacoo has two production bases with an annual capacity of over 100,000 tons,meeting the full-process needs from custom R&D to large-scale production.',
    "businessIntroTitle": "Business Overview",
    "businessItems": ["Polymer \n Materials","Polymer Monomers","Pharmaceutical Intermediates","Electronic Chemical New Materials","Clinical Testing Raw Materials"],
    "caseTabs": [{"title":"Expert Team in Medical Chemistry","description":"Composed of nearly 100 senior scientists and engineers, more than 40% with master's and doctoral degrees, over 150 R&D patents applied, more than 50 approved."},{"title":"First-class R&D and Testing Platform","description":"Built five major experimental platforms including AI intelligent synthesis, chemical synthesis, and biological synthesis, equipped with advanced testing platforms such as HPLC, GC, and polarimeter."},{"title":"International Quality System Assurance","description":"Strictly follow ISO international standards, full-process quality control to ensure high product reliability. From raw material selection to finished products, multi-level testing nodes, full-process quality control."}],
    "coreBusinessTitle": "Core Business",
    "featureTitle": "Featured Services",
    "pageSubtitle": "Medical Chemical CRO+CDMO Custom Service",
    "pageTitle": "Custom Synthesis",
    "processItems": [{"title":"Route Design","desc":["100+ experienced R&D personnel","AI-assisted synthesis route design"]},{"title":"R&D Synthesis","desc":["10,000+㎡ R&D laboratory","Covers 80% of common reactions"]},{"title":"Sample Production","desc":["200,000+㎡ factory production","Strict quality control", "quality assurance"]},{"title":"Packaging & Delivery","desc":["Meet various solid/liquid packaging and delivery requirements","Professional sample delivery/logistics tracking"]}],
    "processTitle": "Custom Synthesis Process",
    "startProject": "Launch Your Customized Project Now",
    "startProjectDesc": 'Submit your requirements and our professional team will provide you with one-on-one technical consultation and customized solutions.',
    "viewMore": "View More"
  },
  "header": {
    "contactUs": "Contact Us",
    "menu": {
      "about": "About Yacoo Science",
      "companyProfile": "Company Profile",
      "customSynthesis": "Customized Services",
      "greenEnergy": "Green Energy",
      "innovation": "Innovation",
      "joinUs": "Join Us",
      "news": "News Center",
      "other": "Other Business",
      "production": "Production Base",
      "products": "Product Center",
      "quality": "Quality Management",
      "rAndDSystem": "R&D System",
      "researchPurchase": "Research Procurement",
      "smartPlatform": "Smart Platform",
      "solution": "Industry Solutions",
      "sustainability": "Sustainable Development",
      "technology": "R&D",
      "testingService": "Testing Services"
    },
    "searchPlaceholder": "Please input search terms..."
  },
  "home": {
    "about": {
      "description": "Established in 2003 and headquartered in Suzhou, China. Yacoo Science has evolved through continuous innovation into a national high-tech enterprise with fully integrated capabilities in research and development, manufacturing. Business scope covers life sciences, personal care, new materials, b2star selection, testing services, etc.",
      "learnMore": "Learn More",
      "subtitle": "Yacoo Science，the global innovator and leader in medical and chemical materials. ",
      "title": "About Yacoo Science"
    },
    "globalService": {
      "description": "Yacoo provides global customers with one-stop CRO+CMO services from custom synthesis to large-scale production,meeting your full-process product needs from scientific research to commercial production.",
      "legend": {
        "customers": {
          "en": "Our Customers",
          "zh": "Our Customers"
        },
        "headquarters": {
          "en": "Yacoo Headquarter",
          "zh": "Yacoo Headquarter"
        },
        "subsidiaries": {
          "en": "Subsidiary Companies",
          "zh": "Subsidiary Companies"
        }
      },
      "stats": {
        "title": "Overseas layout",
        "capacity": "Overseas subsidiaries have been established in Singapore, the United States, and Germany",
        "patents": "The number of global customers exceeds 15,000",
        "team": "Business coverage in more than 70 countries worldwide"
      },
      "title": "Global Service Network"
    },
    "news": {
      "noNews": "No related news",
      "pageTitle": "News Center",
      "searchPlaceholder": "Please enter keywords",
      "title": "Yacoo News",
      "topTag": "Top",
      "viewDetail": "View Details",
      "viewMore": "View More"
    },
    "solutions": {
      "title": "Products & Solutions"
    }
  },
  "jcfw": {
    "businessIntroText1": "Wonder Testing is an independent testing service platform under Yacoo. Based on Yacoo's 22 years of testing experience in the medical chemical materials field,Wonder Testing is committed to building an international quality service platform. According to CMA qualification certification (China Metrology Accreditation) and CNAS laboratory accreditation (ISO/IEC 17025),it provides various (countries/regions) legal/regulatory/technical specification testing services,certification and corresponding consulting services for domestic/foreign manufacturing enterprises/trading companies. Providing customers with one-stop solutions from testing to technical optimization.",
    "businessIntroText2": "The Wonder Testing platform has a 3000㎡ modern laboratory with a domestically leading air circulation and purification system to ensure safe and controllable testing environment. The platform is equipped with comprehensive chemical analysis space and complete high-end instruments to meet high-precision and high-complexity testing needs. According to laws and regulations and technical specifications of various countries/regions (such as EU REACH,US FDA,China CDE,etc.),it helps customers avoid trade barriers and achieve product life cycle compliance management.",
    "businessIntroTitle": "Business Overview",
    "businessItems": ['Inspection and Testing Services','Medical Research and Experimental Development','Testing Technical Services','Certification Services'],
    "businessItemsClass": ['Daily Consumer Goods','Electronic and Electrical Products','Toys and Children\'s Products','Food Contact Materials','Automotive Materials','Light Industrial Goods and Textiles'],
    "businessTip": "The laboratory has established a sound testing service system, which can meet the chemical and physical testing needs of daily consumer goods, electronic and electrical products, toys and children's products, food contact materials, automotive materials, light industrial surplus goods and textiles, etc.",
    "caseTabs": [{"title":"Compliance Testing and Certification Experience","description":"The laboratory relies on Yacoo\'s 22 years of testing service experience in the medical chemical field and is committed to providing compliance testing, certification and technical consulting services for global manufacturing enterprises and traders."},{"title":"International Standard Management System Certification","description":"Testing indicators and management systems comply with international quality system requirements and have been recognized by many international leading customers, ensuring the authority and credibility of testing data."},{"title":"Comprehensive Testing Capability Coverage","description":"Provides comprehensive services in consumer product chemical testing, children's toy safety assessment, textile testing, food contact material compliance testing, automotive material analysis and other fields, helping enterprises meet regulatory requirements of various countries (such as REACH, FDA, CDE, etc.)."}],
    "contact": {
      "address": 'Address: 8F,No.112 Xinqing Road,Suzhou Industrial Park',
      "email": "Email: service@wondertesting.cn",
      "phone": "Tel: +86-18625246998",
      "postcode": "Postcode: 215121"
    },
    "contactTitle": "Contact Us",
    "coreBusinessTitle": "Core Business",
    "equipmentDesc": "By building a comprehensive testing instrument platform covering high-performance liquid chromatographs,gas chromatographs,nuclear magnetic resonance spectrometers,polarimeters,infrared spectrometers,etc.,Yacoo can meet customers' high-precision and high-complexity release testing needs in various impact scenarios.",
    "equipmentList": ["Infrared Spectrometer","Broadband Multi-coil Nuclear Magnetic Resonance Spectrometer","Inductively Coupled Plasma Emission Spectrometer","Karl Fischer Coulometric Moisture Analyzer","GC-MS","Automatic Potentiometric Titrator"],
    "equipmentTitle": "Testing Equipment",
    "featureTitle": "Service Features",
    "nextBtn": "Next",
    "pageSubtitle": "Integrated Service Provider from Independent Testing to Technical Optimization",
    "pageTitle": "Testing Services",
    "platformDesc": "Testing and Certification Integrated Service Provider",
    "prevBtn": "Previous",
    "shopSubtitle": "Integrated Service Provider from Independent Testing to Technical Optimization",
    "shopTitle": "Wonder Testing",
    "viewMore": "View More"
  },
  "kycg": {
    "businessIntroText": "Element Mall (www.b2star.com) is a professional scientific research procurement selection e-commerce platform under Yacoo. By integrating high-quality domestic and foreign brand suppliers,it provides professional scientific reagents,protective equipment,biological consumables,laboratory equipment and other related products,aiming to better meet the diversified needs of customers in life science research,biomedicine and new materials.",
    "businessIntroTitle": "Business Overview",
    "businessItems": [{"title":"Research Reagent" ,"desc":"Biological reagents，Chemical reagents，Analytical reagents，Other reagents"},{"title":"Safety Protection","desc":"Hand Protection, Head Protection, Face Protection, Other Protection"},{"title":"Biological Consumables","desc":"Cell Culture, Medical Consumables, Chromatography Consumables, Testing Consumables, Pipetting Consumables, Tool Consumables"},{"title":"Laboratory Equipment","desc":"Routine Instruments, Testing Instruments, Chromatography Instruments, Special-purpose Instruments, Safety Facilities"}],
    "caseTabs": [{"title":"24-Hour Shipping Guarantee","description":"Multi-warehouse direct dispatch for lightning-fast delivery"},{"title":"6 Million+ Product SKUs","description":"Extensive brands with full-category coverage"},{"title":"600+ Partnered Premium Brands","description":"Authorized distributors with genuine product assurance"},{"title":"Customer-Centric Procurement" ,"description":"Cost-effective solutions with professional support"}],
    "contact": {
      "addressSuqian": "Address (Suqian): 1st Floor,Guke Building (Building A9),E-commerce Industrial Park,Suyu District,Suqian City",
      "addressSuzhou": "Address (Suzhou): No. 112,Xinqing Road,Suzhou Industrial Park",
      "addressWuhan": "Address (Wuhan): Room 07,11th Floor,Building T3,Optics Valley Headquarters Center,No. 766,Gaoxin Avenue,East Lake New Technology Development Zone,Wuhan",
      "addressChengdu": "Address (Chengdu): Room 706, Building 3, Dingsheng International, No. 1 West Wukou Road, Wuhou District, Chengdu City",
      "email": "Email: sxg@b2star.com",
      "phone": "Tel: +86-15335295587"
    },
    "contactTitle": "Contact Us",
    "coreBusinessTitle": "Core Business",
    "enterShop": "Enter Shop",
    "featureTitle": "Service Features",
    "pageSubtitle": "An e-commerce platform for scientific research procurement selection",
    "pageTitle": "Research Selection",
    "shopBusiness": ["Research Reagent","Safety Protection","Biological Consumables","Laboratory Equipment"],
    "shopSubtitle": "An e-commerce platform for scientific research procurement selection",
    "shopTitle": "B2star"
  },
  "lsny": {
    "businessIntroText": "Goodenoughchem is a green energy service platform under Yacoo Science, Co., Ltd., Ltd. The independently developed flame-retardant in-situ curing agent, which effectively improves battery safety, has been recognized by many leading enterprises for cooperation. As an integrated service provider of new energy lithium battery materials,Goodenoughchem can meet your all-round needs from scientific research to large-scale production, providing basic electrolyte configuration, electrolyte raw materials, special functional electrolytes, as well as professional large-volume electrolyte configuration/electrolyte customization services.",
    "businessIntroTitle": "Business Overview",
    "businessItems": [{"title": "Electrolyte"},{"title": "Chemical Reagents"},{"title": "Battery Materials"},{"title": "Special Functional Electrolyte"}],
    "caseTabs": [{"title":"Rich Product Matrix","description":"Nearly 100 types of new energy lithium battery additives developed, can provide Li/Na/Mg/Al electrolytes"},{"title":"From R&D Customization to Mass Production","description":"Industrialization capability of over 10 lithium battery functional materials, with ethoxyphosphazene series planned for 100-ton capacity"},{"title":"Recognized by Leading Enterprises","description":"Solid flame retardant products meet international standards and are recognized by many leading new energy enterprises in China"}],
    "contactAddress": "Address: 8th Floor,No. 112 Xinqing Road,Suzhou Industrial Park",
    "contactEmail": "Email: sales022@b2star.com",
    "contactPhone": "Tel: 18136447806",
    "contactPostcode": "Postcode: 215121",
    "contactQQ": "QQ: 693755679",
    "contactSubtitle": "Integrated Service Provider of New Energy Lithium Battery Materials",
    "contactTitle": "Contact Us",
    "coreBusinessTitle": "Core Business",
    "enterShop": "Learn More",
    "featureTitle": "Service Features",
    "pageSubtitle": "Integrated Service Provider of New Energy Lithium Battery Materials",
    "pageTitle": "Green Energy",
    "shopSubtitle": "Integrated Service Provider of New Energy Lithium Battery Materials",
    "shopTitle": "Gudina New Energy"
  },
  "news": {
    "noNews": "No related news",
    "pageTitle": "News Center",
    "searchPlaceholder": "Please enter keywords",
    "title": "Yacoo News",
    "topTag": "Top",
    "viewDetail": "View Details",
    "viewMore": "View More"
  },
  "products": {
    "centerTitle": "Product Center",
    "detail": {
      "advantages": "Service Advantages",
      "batchInquiry": "Bulk purchase inquiry",
      "breadcrumbCenter": "Product Center",
      "breadcrumbHome": "Home Page",
      "cas": "CAS: {cas}",
      "customSynthesis": "Custom Synthesis Consultation",
      "featured": "Hot-selling Products Recommendation",
      "features": "Product Features",
      "getSample": "Require Samples",
      "noData": "No Data",
      "notes": "Notes",
      "related": "Related Products",
      "researchPurchase": "Research Procurement"
    },
    "mainProducts": "Main Products",
    "noData": "No Data",
    "searchBtn": "Search",
    "searchPlaceholder": "Please enter product name,item number,CAS number or keyword",
    "panel": {
      "EnglishName": "English Name",
      "Alias": "Alias",
      "Name": "Product Name",
      "CAS": "CAS Number",
      "ArtNo": "Product Code",
      "UsagePlatform": "Usage Platform",
      "molecularFormula": "Molecular Formula",
      "molecularWeight": "Molecular Weight",
      "ec": "EC Number",
      "enzymeActivity": "Enzyme Activity",
      "activity": "Activity",
    }
  },
  "solution": {
    "learnMore": "Learn More",
    "pageSubtitle": "Promoting Technological Progress and Innovation in Medical Chemical Materials",
    "pageTip": "Yacoo has always been committed to promoting the technological progress and innovation of medical chemical materials. Based on technological innovation and stable supply to meet customers' professional needs,we provide high-quality,convenient,and cost-effective diversified products and services,promote the continuous progress of the medical chemical materials industry,and build a green and healthy future together.",
    "pageTitle": "Industry Solutions",
    "tableName": "Product Name",
  },
  "sustainability": {
    "conceptText": "Yacoo consistently upholds the philosophy of sustainable development,integrating green innovation into the entire process of R&D,production,and operations. We are committed to reducing carbon footprint through environmental process optimization,resource recycling,and clean energy applications; promoting the development of degradable materials and green solutions through technological innovation,helping the industry achieve low-carbon transformation. Meanwhile,we actively practice social responsibility,building a symbiotic and win-win system with employees,communities,and the environment,striving for coordinated development of economic,ecological,and social benefits,contributing to global sustainable development goals.",
    "conceptTitle": "Sustainable Development Philosophy",
    "dataSection": {
      "highConcentrationGas": "Proportion of green electricity consumption",
      "lowConcentrationGas": "CO₂ equivalent/million yuan",
      "wastewaterTreatment": "Social public welfare donations in 2024",
      "solidWasteStorage": "Book donations to No. 2 Middle School of Kizilsu Kirghiz Autonomous Prefecture, Xinjiang",
      "units": {
        "cubicMeterPerHour": "%",
        "ton": "tons",
        "tonPerDay": "volumes",
        "yuan": "yuan"
      }
    },
    "environmentalProtection": {
      "altText": "Environmental Protection",
      "description": "Yacoo strictly complies with national and local environmental protection laws and regulations as well as other relevant provisions,and has passed ISO14001 environmental management system certification. With complete three-waste treatment facilities,through the introduction of advanced wastewater,exhaust gas,and solid waste treatment facilities,we can safely carry out production activities while ensuring environmental friendliness.",
      "title": "Environmental Protection"
    },
    "greenDevelopment": {
      "buildingAlt": "Yacoo Headquarters Building",
      "description": "Adhering to the corporate mission of Transcending Medical Chemical Boundaries,Creating a Green Future Together,Yacoo always takes green development as its responsibility whether in infrastructure construction or product development. The group headquarters building has won the LEED (Leadership in Energy and Environmental Design) Platinum certification issued by the US Green Building Council,achieving energy supply through green power equipment such as solar panels. Yacoo's bio-based new material poly(2 \, 5-furandicarboxylic acid ethylene glycol ester) (PEF) produced from renewable crops can be widely used in bottle sheet applications,significantly reducing the overall carbon footprint in the product production process.",
      "title": "Green Development"
    },
    "pageSubtitle": "Medical Chemical CRO+CDMO Custom Service",
    "pageTitle": "Sustainable Development",
    "safetyProduction": {
      "certificateAlt": "Environmental Certification Certificate",
      "description": "Yacoo has formulated a comprehensive safety production management system in accordance with ISO45001 occupational health and safety management system requirements. Through informatization and intelligent facilities,we safeguard the safety lifeline. Taking Yacoo Anqing production base as an example,the base has obtained production safety standardization level 3 certification,built a safety production informatization system,and realized a five-in-one safety risk prevention and control system including personnel positioning,intelligent inspection,and dual prevention.",
      "title": "Safety Production"
    }
  },
  "technology": {
    "achievementsTitle": "Innovation Achievements",
    "businessIntroText": "YACOO has a R&D center of over 10,000 square meters, equipped with cutting-edge equipment such as an AI synthesis platform and microchannel continuous flow reactors, and has formed a R&D team of more than 100 people with masters and doctors as the core. Yacoo collaborates with leading institutions such as the Ningbo Institute of Materials (CAS), Nanjing Tech University, and Soochow University. Yacoo has established innovation platforms such as \"Suzhou New Electronic Chemical Materials Engineering Technology Center\", \"University-Enterprise Collaborative Workstation\", and \"Jiangsu Functional Electronic Chemical Materials Engineering Technology Research Center\", forming a complete R&D system and system, providing a solid guarantee for the company's technological innovation and product upgrading.Up to now, the enterprise has applied for more than 150 patents.",
    "businessIntroTitle": "Comprehensive R&D System",
    "businessItems": [{"title":"Biomedical Purifiers and Structural Chemicals"},{"title":"High-end In Vitro Diagnostic Reagent Development"},{"title":"Enzyme Development"},{"title":"High-end Biopolymer Material Development"},{"title":"Semiconductor-grade Electronic Chemicals and New Energy Battery Materials"}],
    "consultBtn": "Customized Consultation",
    "customServiceDesc": "Based on 22 years of R&D experience in the field of medical chemical materials,Yacoo can provide customers with reliable and stable custom synthesis services.",
    "customServiceTitle": "Customized Services from Gram to Ton Scale",
    "leadingProcess": "Leading Technology",
    "pageTitle": "Intelligence-Driven Technology,Envisioning the Future",
    "platformList": [{"title":"AI Intelligent Laboratory","description":"The AI intelligent synthesis laboratory is equipped with AI intelligent synthesizers that can customize reaction steps and parameters, monitor the reaction process in real time, quickly screen process conditions and predict optimal reaction conditions, improving R&D efficiency."},{"title":"High-end Reagent Purification Laboratory","description":"Used for the purification of pharmaceutical-grade chemicals and semiconductor-grade electronic materials. The laboratory is equipped with advanced purification equipment for distillation and membrane filtration of acids, alcohols, amines, nitriles, etc."},{"title":"New Energy Electrolyte Laboratory Platform","description":"The platform can conduct experiments on electrolyte flame retardants and electrolytes. Equipped with advanced equipment, it has successfully developed phosphazene flame retardants. It can continuously develop liquid and semi-liquid battery materials according to customers' battery technology routes."},{"title":"Green Biotechnology Laboratory Platform","description":"Biosynthesis is carried out at room temperature and pressure, with low energy consumption, no need for organic solvents, and little or no toxic by-products. The platform is developing enzyme-catalyzed biological buffer products, new diagnostic substrates, and high molecular polyester materials."},{"title":"Chemical Synthesis Laboratory Platform","description":"In addition to traditional synthesis equipment, the chemical synthesis laboratory is also equipped with NMR, MS, HPLC, microchannel continuous flow automatic synthesis workstation, and LIMS. It can develop pharmaceutical excipients, diagnostic substrates, and high molecular composite materials, including customer customization."}],
    "platformTitle": "Five Intelligent R&D Platforms",
    "serviceIcons": ["Biomedical Purifiers and Structural Chemicals","High-end In Vitro Diagnostic Reagent Development","Enzyme Development","High-end Biopolymer Material Development","Semiconductor-grade Electronic Chemicals and New Energy Battery Materials"],
    "starProduct": "Innovative Products"
  },
  "footer": {
    "contact": {
      "phone": "Phone",
      "email": "Email"
    },
    "qrCode": {
      "scanToFollow": "Scan to follow us"
    },
    "socialMedia": {
      "wechat": "WeChat",
      "tiktok": "TikTok",
      "xiaohongshu": "Xiaohongshu"
    },
    "copyright": "© 2025 SuZhou Yacoo Science Co., Ltd., Suzhou, China [ICP License No. 15045967]"
  },
  "croCdmoDialog": {
    "logoAlt": "Yacoo Logo",
    "hotline": "Free Service Hotline: ",
    "description": "Please leave your requirements and we will contact you within 1 business day",
    "form": {
      "name": "Name",
      "namePlaceholder": "Please enter your name",
      "contact": "Contact",
      "contactPlaceholder": "Please enter your phone/mobile/email",
      "company": "Company",
      "companyPlaceholder": "Please enter your company name",
      "product": "Product Name",
      "productPlaceholder": "Please enter product name",
      "cas": "CAS No.",
      "casPlaceholder": "Please enter CAS number",
      "requirement": "Purchase Requirement",
      "requirementPlaceholder": "Please enter your purchase requirements",
      "attachment": "Attachment",
      "submit": "Submit"
    },
    "upload": {
      "clickToUpload": "Click to upload attachment",
      "fileFormat": "File format: jpg, pdf, doc, file size not exceeding 5M",
      "fileSizeError": "File size cannot exceed 5M",
      "fileTypeError": "Please upload jpg, pdf or doc format files",
      "uploadSuccess": "File uploaded successfully",
      "uploadFailed": "File upload failed, please try again"
    },
    "validation": {
      "nameRequired": "Please enter your name",
      "contactRequired": "Please enter your contact information",
      "casRequired": "Please enter CAS number"
    },
    "messages": {
      "submitSuccess": "Submitted successfully",
      "submitFailed": "Submission failed",
      "submitFailedRetry": "Submission failed, please try again later"
    }
  },
  "productDialog": {
    "logoAlt": "Yacoo Logo",
    "hotline": "Free Service Hotline: ",
    "description": "Please leave your requirements and we will contact you within 1 business day",
    "form": {
      "name": "Name",
      "namePlaceholder": "Please enter your name",
      "contact": "Contact",
      "contactPlaceholder": "Please enter your phone/mobile/email",
      "company": "Company",
      "companyPlaceholder": "Please enter your company name",
      "product": "Product Name",
      "productPlaceholder": "Please enter product name",
      "cas": "CAS No.",
      "casPlaceholder": "Please enter CAS number",
      "requirement": "Purchase Requirement",
      "requirementPlaceholder": "Please enter your purchase requirements",
      "submit": "Submit"
    },
    "validation": {
      "nameRequired": "Please enter your name",
      "contactRequired": "Please enter your contact information",
      "casRequired": "Please enter CAS number"
    },
    "messages": {
      "submitSuccess": "Submitted successfully",
      "submitFailed": "Submission failed",
      "submitFailedRetry": "Submission failed, please try again later"
    }
  },
  "serviceDialog": {
    "logoAlt": "Yacoo Logo",
    "hotline": "Free Service Hotline: ",
    "description": "Please leave your requirements and we will contact you within 1 business day",
    "form": {
      "name": "Name",
      "namePlaceholder": "Please enter your name",
      "contact": "Contact",
      "contactPlaceholder": "Please enter your phone/mobile/email",
      "company": "Company",
      "companyPlaceholder": "Please enter your company name",
      "service": "Service Name",
      "servicePlaceholder": "Please enter service name",
      "requirement": "Requirement",
      "requirementPlaceholder": "Please enter your customization requirements",
      "submit": "Submit"
    },
    "validation": {
      "nameRequired": "Please enter your name",
      "contactRequired": "Please enter your contact information"
    },
    "messages": {
      "submitSuccess": "Submitted successfully",
      "submitFailed": "Submission failed",
      "submitFailedRetry": "Submission failed, please try again later"
    }
  },
  "purchaseDialog": {
    "logoAlt": "Yacoo Logo",
    "title": "More brand products available at B2star",
    "gotoStore": "Visit B2star",
    "storeInfo": "Provided by B2star under Yacoo Group"
  },
  "purchaseListDialog": {
    "logoAlt": "Yacoo Logo",
    "productInfo": "Product Information",
    "unitPrice": "Unit Price (Including Tax)",
    "more": "More",
    "productCode": "Product Code: ",
    "itemNumber": "Item Number: ",
    "specification": "Specification: ",
    "parameter": "Parameter: ",
    "contactSales": "Contact Sales for Quote",
    "gotoShop": "Visit Mall",
    "storeInfo": "Provided by B2star under Yacoo Group"
  },
  "resumeDialog": {
    "logoAlt": "Yacoo Logo",
    "upload": {
      "clickToUpload": "Click to upload resume",
      "fileFormat": "File format: jpg, pdf, ppt, file size not exceeding 5M",
      "fileSizeError": "File size cannot exceed 5M",
      "fileTypeError": "Please upload jpg, pdf or ppt format files"
    },
    "fileInfo": {
      "removeFile": "Remove file"
    },
    "submit": "Send",
    "messages": {
      "uploadSuccess": "Resume submitted successfully",
      "uploadFailed": "Upload failed, please try again",
      "jobNotExist": "Job information does not exist",
      "pleaseUploadFirst": "Please upload resume first"
    }
  },
  "goodChart": {
    "logoAlt": "Yacoo Logo",
    "companyName": "Yacoo Science",
    "consultationPhone": "Consultation Phone: ",
    "productService": "Product Consultation & After-sales Service: ",
    "contactEmail": "Contact Email: ",
    "leaveMessage": "Leave Message"
  },
  "searchPage": {
    "pageTitle": "Site Search",
    "searchInfo": "Search: {keyword}",
    "loading": "Loading...",
    "noData": "No Data",
    "noNews": "No related news",
    "noProducts": "No related products",
    "productInfo": {
      "casNo": "CAS No.: ",
      "itemNumber": "Item No.: ",
      "specification": "Specification: ",
      "parameter": "Parameter: ",
      "price": "Price: ",
      "unit": "Unit: ",
      "inquiry": "Inquiry",
      "chemicalName": "Chemical Name"
    },
    "newsInfo": {
      "typeTag": "Type Tag"
    },
    "pagination": {
      "prev": "Previous",
      "next": "Next"
    }
  }
};
